export const CAMPAIGN_STATES = [
  { tab: 0, value: "active", labelKey: "Active", archived: false },
  { tab: 1, value: "next", labelKey: "Next", archived: false },
  { tab: 2, value: "pending", labelKey: "Pending approval", archived: false },
  { tab: 3, value: "payment_pending", labelKey: "Still to be paid", archived: false },
  { tab: 4, value: "previous", labelKey: "Previous", archived: false },
  { tab: 5, value: "archived", labelKey: "Archived", archived: true },
];

export const PROPOSAL_STATES = [
  { tab: 0, value: "proposal", labelKey: "In force", archived: false },
  { tab: 1, value: "archived_proposal", labelKey: "Archived", archived: true },
];

export const DEFAULT_PAGE_LENGTH = 18;

export const getStateByTab = (tabKey) => {
  const index = parseInt(tabKey, 10);
  const entry = CAMPAIGN_STATES.find((s) => s.tab === index);
  return entry ? entry.value : CAMPAIGN_STATES[0].value;
};

export const getTabByState = (stateValue) => {
  const entry = CAMPAIGN_STATES.find((s) => s.value === stateValue);
  return entry ? String(entry.tab) : "0";
};
